import { Routes, Route } from 'react-router-dom';

import Pages from './pages';

const Routing = () => {
  return (
    <Routes>
      <Route path="/" element={<Pages.Login />} />
      <Route path="/forgot-password" element={<Pages.ForgotPassword />} />
      <Route path="/reset-password" element={<Pages.ResetPassword />} />
      <Route path="/verify-otp" element={<Pages.Verification />} />
      <Route path="/dashboard" element={<Pages.Dashboard />} />
      <Route path="/registrations/individual" element={<Pages.Individuals />} />
      <Route path="/registrations/dealers" element={<Pages.Dealers />} />
      <Route path="/registrations/stores" element={<Pages.Stores />} />
      <Route path="/blogs" element={<Pages.Blogs />} />
      <Route path="/blogs/add" element={<Pages.AddBlog />} />
      <Route path="/blogs/edit/:id" element={<Pages.AddBlog />} />
      <Route path="/inspection-requests" element={<Pages.InspectionRequests />} />
      <Route path="/financial-requests" element={<Pages.FinancialRequests />} />
      <Route path="/permission-denied" element={<Pages.PermissionDenied />} />
      <Route path="/manage-packages" element={<Pages.ManagePackages />} />
      <Route path="/manage-packages/add" element={<Pages.AddPackage />} />
      <Route path="/manage-packages/edit/:id" element={<Pages.AddPackage />} />
      <Route path="/manage-promo-codes" element={<Pages.ManagePromoCodes />} />
      <Route path="/manage-promo-codes/add" element={<Pages.AddPromoCode />} />
      <Route path="/manage-CustomerSupport" element={<Pages.ManageCustomerSupport />} />

      <Route path="/manage-promo-codes/edit/:id" element={<Pages.AddPromoCode />} />
      <Route path="/manage-promo-codes/view/:id" element={<Pages.PromoCodeDetail />} />
      <Route path="/manage-vehicle-types" element={<Pages.VehicleTypes />} />
      <Route path="/manage-vehicle-types/add" element={<Pages.AddVehicleTypes />} />
      <Route path="/manage-vehicle-types/edit/:id" element={<Pages.AddVehicleTypes />} />
      <Route path="/listings/individual" element={<Pages.IndividualListings />} />
      <Route path="/listings/dealers" element={<Pages.DealerListings />} />
      <Route path="/listings/stores" element={<Pages.StoreListings />} />
      <Route path="/listings/myList" element={<Pages.MyListings />} />
      <Route path="/listings/add" element={<Pages.AddVehicle />} />
      <Route path="/listings/edit/:id" element={<Pages.AddVehicle />} />
      {/* ------------------ */}

      {/* dealer store */}
      <Route path="/manage-store" element={<Pages.ManageStore />} />
      <Route path="/manage-store/view/:id" element={<Pages.DealerStoreDetail />} />

      {/* Brands */}
      <Route path="/vehicle-specifications/brands" element={<Pages.Brands />} />
      <Route path="/vehicle-specifications/brands/add" element={<Pages.AddBrand />} />
      <Route path="/vehicle-specifications/brands/edit/:id" element={<Pages.AddBrand />} />
      {/* financial year */}
      <Route path="/vehicle-specifications/financial-year" element={<Pages.FinancialYears />} />
      <Route
        path="/vehicle-specifications/financial-year/add"
        element={<Pages.AddFinancialYear />}
      />
      <Route
        path="/vehicle-specifications/financial-year/edit/:id"
        element={<Pages.AddFinancialYear />}
      />

      {/* Brand Trim */}
      <Route path="/vehicle-specifications/brands-trim" element={<Pages.TrimBrand />} />
      <Route path="/vehicle-specifications/brands-trim/add" element={<Pages.AddTrimBrand />} />
      <Route path="/vehicle-specifications/brands-trim/edit/:id" element={<Pages.AddTrimBrand />} />

      {/* Features */}
      <Route path="/vehicle-specifications/features" element={<Pages.ManageFeatures />} />

      <Route path="/vehicle-specifications/features/add" element={<Pages.AddFeatures />} />
      <Route path="/vehicle-specifications/features/edit/:id" element={<Pages.AddFeatures />} />

      {/* Technical Features */}
      <Route
        path="/vehicle-specifications/technical-features"
        element={<Pages.ManageTechFeatures />}
      />
      <Route
        path="/vehicle-specifications/technical-features/add"
        element={<Pages.AddTechnicalFeatures />}
      />
      <Route
        path="/vehicle-specifications/technical-features/edit/:id"
        element={<Pages.AddTechnicalFeatures />}
      />
      {/* Regional Spec */}
      <Route
        path="/vehicle-specifications/regional-specifications"
        element={<Pages.RegionalSpec />}
      />
      <Route
        path="/vehicle-specifications/regional-specifications/add"
        element={<Pages.AddRegionalSpec />}
      />
      <Route
        path="/vehicle-specifications/regional-specifications/edit/:id"
        element={<Pages.AddRegionalSpec />}
      />

      {/* Equipments */}
      <Route path="/vehicle-specifications/equipments" element={<Pages.ManageEquipments />} />
      <Route path="/vehicle-specifications/equipments/add" element={<Pages.AddEquipment />} />
      <Route path="/vehicle-specifications/equipments/edit/:id" element={<Pages.AddEquipment />} />
      {/* Model */}
      <Route path="/vehicle-specifications/model" element={<Pages.Modal />} />
      <Route path="/vehicle-specifications/model/add" element={<Pages.AddModal />} />
      <Route path="/vehicle-specifications/model/edit/:id" element={<Pages.AddModal />} />
      {/* Model Trim */}
      <Route path="/vehicle-specifications/model-trim" element={<Pages.TrimModal />} />
      <Route path="/vehicle-specifications/model-trim/add" element={<Pages.AddTrimModal />} />
      <Route path="/vehicle-specifications/model-trim/edit/:id" element={<Pages.AddTrimModal />} />

      {/* Drive Type */}
      <Route path="/vehicle-specifications/drive-type" element={<Pages.DriveType />} />
      <Route path="/vehicle-specifications/drive-type/add" element={<Pages.AddDriveType />} />
      <Route path="/vehicle-specifications/drive-type/edit/:id" element={<Pages.AddDriveType />} />
      {/* Power */}
      <Route path="/vehicle-specifications/power" element={<Pages.Power />} />
      <Route path="/vehicle-specifications/power/add" element={<Pages.AddPower />} />
      <Route path="/vehicle-specifications/power/edit/:id" element={<Pages.AddPower />} />

      {/* Gcc */}

      <Route path="/vehicle-specifications/gcc" element={<Pages.ManageGCC />} />
      <Route path="/vehicle-specifications/gcc/add" element={<Pages.AddGCC />} />
      <Route path="/vehicle-specifications/gcc/edit/:id" element={<Pages.AddGCC />} />
      {/* Colors */}
      <Route path="/vehicle-specifications/colors" element={<Pages.ColorCode />} />
      <Route path="/vehicle-specifications/colors/add" element={<Pages.AddColorCode />} />
      <Route path="/vehicle-specifications/colors/edit/:id" element={<Pages.AddColorCode />} />
      {/* Body Type */}
      <Route path="/vehicle-specifications/body-type" element={<Pages.BodyType />} />

      <Route path="/vehicle-specifications/body-type/add" element={<Pages.AddBodyType />} />
      <Route path="/vehicle-specifications/body-type/edit/:id" element={<Pages.AddBodyType />} />

      {/* Damage Type */}
      <Route path="/vehicle-specifications/damage-type" element={<Pages.FleetDamage />} />

      <Route path="/vehicle-specifications/damage-type/add" element={<Pages.AddFleetDamage />} />
      <Route
        path="/vehicle-specifications/damage-type/edit/:id"
        element={<Pages.AddFleetDamage />}
      />

      {/* Fuel Type */}
      <Route path="/vehicle-specifications/fuel-type" element={<Pages.FuelType />} />

      <Route path="/vehicle-specifications/fuel-type/add" element={<Pages.AddFuelType />} />
      <Route path="/vehicle-specifications/fuel-type/edit/:id" element={<Pages.AddFuelType />} />

      {/* Engine Capacity*/}
      <Route path="/vehicle-specifications/engine-capacity" element={<Pages.EngineCapacity />} />

      <Route
        path="/vehicle-specifications/engine-capacity/add"
        element={<Pages.AddEngineCapacity />}
      />
      <Route
        path="/vehicle-specifications/engine-capacity/edit/:id"
        element={<Pages.AddEngineCapacity />}
      />
      {/* Engine Capacity*/}
      <Route
        path="/vehicle-specifications/loan-interest-rates"
        element={<Pages.LoanInterestRates />}
      />

      <Route
        path="/vehicle-specifications/loan-interest-rates/add"
        element={<Pages.AddLoanInterestRates />}
      />
      <Route
        path="/vehicle-specifications/loan-interest-rates/edit/:id"
        element={<Pages.AddLoanInterestRates />}
      />

      {/* ------------- */}

      <Route path="/manage-payment" element={<Pages.Payment />} />
      <Route path="/manage-analytics" element={<Pages.Analytics />} />

      <Route path="/promotional-campaigns" element={<Pages.PromotionalCampaign />} />
      <Route path="/promotional-campaigns/add" element={<Pages.AddPromotionalCampaign />} />
      <Route path="/promotional-campaigns/edit/:id" element={<Pages.AddPromotionalCampaign />} />
      <Route path="/ratings-and-reviews" element={<Pages.RatingsAndReviews />} />
      <Route path="/listing-detail/:type/:id" element={<Pages.VehicleDetail />} />

      <Route path="/dashboard/downloaded-users" element={<Pages.DownloadedUsers />} />

      <Route path="/dashboard/registered-users" element={<Pages.RegisteredUsers />} />

      <Route path="/report-an-issue" element={<Pages.ReportAnIssue />} />

      <Route path="/reports" element={<Pages.Reports />} />
      <Route path="/user-management/roles" element={<Pages.Roles />} />
      <Route path="/user-management/user-list" element={<Pages.UserList />} />
      <Route path="/broadcast-message" element={<Pages.BroadcastMessage />} />
      <Route path="/chat" element={<Pages.Chat />} />
      <Route path="/profile-detail/:type/:id" element={<Pages.ProfileDetail />} />
      <Route path="/edit-profile-detail/:type/:id" element={<Pages.EditProfile />} />
      <Route path="/my-profile" element={<Pages.MyProfile />} />
      <Route path="/manage-notifications" element={<Pages.ManageNotifications />} />
      <Route path="/recieved-notifications" element={<Pages.RecievedNotifications />} />
      <Route path="/manage-cms" element={<Pages.ManageCms />} />
      <Route path="/manage-newsletter-users" element={<Pages.NewsLetterEmail />} />
    </Routes>
  );
};

export default Routing;
